import resolve from './resolve';
import axios from 'axios';
import { IMeter, IMeta } from '../models/IMeter';
import { URL_SERVER } from '../utils/const';

interface returnMetersI {
	message: string;
	data: IMeter[];
	meta: IMeta[];
}
interface searchI {
	[key: string]: { value: string; filterType: string };
}

export async function returnMetersExcel(): Promise<any> {
	return await resolve(
		axios.get<IMeter[]>(`${URL_SERVER}/m_0002/export`, {
			withCredentials: true,
		})
	);
}

export async function returnMeters(
	page: number,
	sizePerPage: number,
	sort: {
		sortOrder: string;
		sortField: string;
	},
	search: searchI
): Promise<any> {
	const reqSearch = () => {
		const searchObj: searchI = {};

		Object.keys(search).forEach((key) => {
			if (search[key]) {
				searchObj[key] = { value: String(search[key]), filterType: 'input' };
			}
		});
		return JSON.stringify(searchObj);
	};

	const params: {
		page: number;
		filter?: string;
		rows: number;
		sort?: { name: string; sortOrder: string };
	} = {
		page: page,
		filter: reqSearch(),
		rows: sizePerPage,
		sort: {
			name: sort.sortField,
			sortOrder: sort.sortOrder,
		},
	};
	if (sort.sortField === '' && sort.sortOrder === '') {
		delete params.sort;
	}
	if (reqSearch() === '{}') {
		delete params.filter;
	}

	return await resolve(
		axios.get<returnMetersI>(`${URL_SERVER}/m_0002/list`, {
			withCredentials: true,
			params: params,
		})
	);
}

export async function deleteMeters(id: string): Promise<void> {
	return await resolve(
		axios.delete(`${URL_SERVER}/m_0002/${id}`, {
			withCredentials: true,
		})
	);
}

export async function clearAllCache(): Promise<any> {
	return await resolve(
		axios.get(`${URL_SERVER}/cache/clear_all`, {
			withCredentials: true,
		})
	);
}

export async function clearCache(number: string): Promise<any> {
	return await resolve(
		axios.get(`${URL_SERVER}/cache/clear`, {
			withCredentials: true,
			params: {
				number: number
			},
		})
	);
}